export default __webpack_public_path__ + "static/media/menu3.50d752a7.jpeg";